export enum AppEvent {
  NAVIGATE = 'NAVIGATE',
  SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
}
